import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";


interface GetLinksParameters {
  parameters: {
    [key: string]: any; // Adjust the type according to your parameter structure
  };
}

interface GetLinksResponse {
  list: any; // Replace with the actual data structure of the response
  totalCount: number;
  currentPage: number;
}

interface GetLinksError {
  message: string; // Error message structure
}


export const getLinks = createAsyncThunk<GetLinksResponse, GetLinksParameters, { rejectValue: GetLinksError }>(
  "/links",
  async ( parameters , { rejectWithValue }) => {
    try {

      const method = "/get-payment-links";

      const { data, errorMessage, isSuccess } = await commonNetwork.post(method, parameters);

      if (isSuccess) {
        // Artık pagination'lı gelecek => data = { data: [...], totalCount: 123 }
        const list = data.data || [];  // customer listesi
        const totalCount = data.totalCount || 0;
        const currentPage = data.currentPage || 1;

        return { list, totalCount, currentPage };  // explicit döndür
      } else {
        return rejectWithValue(data);
      }
    } catch (e: any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const linkListSlice = createSlice({
  name: "linklist",
  initialState: {
    links: [],
    totalCount: 0,
    currentPage: 1,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    selectedCustomer: {},
    isfetchComplete: false
  },
  reducers: {
    clearState: (state) => {
      state.links = [];
      state.selectedCustomer = {};
      state.isfetchComplete = false;
      return state;
    },
    onSelectOrderLinkListCustomer: (state, action) => {
      state.selectedCustomer = action.payload;

      return state;
    },
    clearOrderLinkListCustomer: (state, action) => {
      state.selectedCustomer = {};
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLinks.fulfilled, (state, { payload }) => {
      state.links = payload.list;
      state.totalCount = payload.totalCount; // totalCount
      state.currentPage = payload.currentPage; // currentPage
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isfetchComplete = true;
      return state;
    });
    builder.addCase(getLinks.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getLinks.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState, onSelectOrderLinkListCustomer, clearOrderLinkListCustomer } = linkListSlice.actions;

export const linkListSelector = (state: any) => state.linklist;

export const linkListReducer = linkListSlice.reducer;
